export enum IntegrationEnum {
    WORLD_OFFICE = 'worldOffice',
    SIIGO = 'siigo',
    BUSINESS_CENTRAL = 'business_central',
}
